/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteVehiclesParams,
  GetVehiclesParams,
  PatchVehiclesParams,
  PostVehiclesParams,
  PostgrestError,
  Vehicles,
  VehiclesInsertPayload,
  VehiclesUpdate
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getVehiclesResponse200 = {
  data: Vehicles[]
  status: 200
}

export type getVehiclesResponse206 = {
  data: Vehicles[]
  status: 206
}

export type getVehiclesResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getVehiclesResponseSuccess = (getVehiclesResponse200 | getVehiclesResponse206) & {
  headers: Headers;
};
export type getVehiclesResponseError = (getVehiclesResponseDefault) & {
  headers: Headers;
};

export type getVehiclesResponse = (getVehiclesResponseSuccess | getVehiclesResponseError)

export const getGetVehiclesUrl = (params?: GetVehiclesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/vehicles?${stringifiedParams}` : `${backendBaseUrl}/vehicles`
}

/**
 * @summary Read rows from `vehicles`.
 */
export const getVehicles = async (params?: GetVehiclesParams, options?: RequestInit): Promise<getVehiclesResponse> => {

  const res = await fetch(getGetVehiclesUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getVehiclesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getVehiclesResponse
}


export type postVehiclesResponse201 = {
  data: Vehicles[]
  status: 201
}

export type postVehiclesResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postVehiclesResponseSuccess = (postVehiclesResponse201) & {
  headers: Headers;
};
export type postVehiclesResponseError = (postVehiclesResponseDefault) & {
  headers: Headers;
};

export type postVehiclesResponse = (postVehiclesResponseSuccess | postVehiclesResponseError)

export const getPostVehiclesUrl = (params?: PostVehiclesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/vehicles?${stringifiedParams}` : `${backendBaseUrl}/vehicles`
}

/**
 * @summary Insert one or more rows into `vehicles`.
 */
export const postVehicles = async (vehiclesInsertPayload: VehiclesInsertPayload,
    params?: PostVehiclesParams, options?: RequestInit): Promise<postVehiclesResponse> => {

  const res = await fetch(getPostVehiclesUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vehiclesInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postVehiclesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postVehiclesResponse
}


export type patchVehiclesResponse200 = {
  data: Vehicles[]
  status: 200
}

export type patchVehiclesResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchVehiclesResponseSuccess = (patchVehiclesResponse200) & {
  headers: Headers;
};
export type patchVehiclesResponseError = (patchVehiclesResponseDefault) & {
  headers: Headers;
};

export type patchVehiclesResponse = (patchVehiclesResponseSuccess | patchVehiclesResponseError)

export const getPatchVehiclesUrl = (params?: PatchVehiclesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/vehicles?${stringifiedParams}` : `${backendBaseUrl}/vehicles`
}

/**
 * @summary Update the rows of `vehicles` matching the given filters.
 */
export const patchVehicles = async (vehiclesUpdate: VehiclesUpdate,
    params?: PatchVehiclesParams, options?: RequestInit): Promise<patchVehiclesResponse> => {

  const res = await fetch(getPatchVehiclesUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(vehiclesUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchVehiclesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchVehiclesResponse
}


export type deleteVehiclesResponse200 = {
  data: Vehicles[]
  status: 200
}

export type deleteVehiclesResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteVehiclesResponseSuccess = (deleteVehiclesResponse200) & {
  headers: Headers;
};
export type deleteVehiclesResponseError = (deleteVehiclesResponseDefault) & {
  headers: Headers;
};

export type deleteVehiclesResponse = (deleteVehiclesResponseSuccess | deleteVehiclesResponseError)

export const getDeleteVehiclesUrl = (params?: DeleteVehiclesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/vehicles?${stringifiedParams}` : `${backendBaseUrl}/vehicles`
}

/**
 * @summary Delete the rows of `vehicles` matching the given filters.
 */
export const deleteVehicles = async (params?: DeleteVehiclesParams, options?: RequestInit): Promise<deleteVehiclesResponse> => {

  const res = await fetch(getDeleteVehiclesUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteVehiclesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteVehiclesResponse
}


